import 'react-datepicker/dist/react-datepicker.css';
import React from 'react';
import DatePicker from 'react-datepicker';
import classNames from 'classnames/bind';
import styles from './DatePickerField.scss';
const cx = classNames.bind(styles);
const DatePickerField = ({ disabled, ...props }) => {
    return (React.createElement(DatePicker, { ...props, disabled: disabled, wrapperClassName: cx('datePicker', { disabled }), showYearDropdown: true, showMonthDropdown: true, scrollableYearDropdown: true }));
};
export default DatePickerField;
